<!--
 * @Descripttion: 企业信息弹框
 * @Date: 2024-12-06 13:50:47
-->
<template>
  <BaseDialog
    :title="!isIframe ? '账号信息' : '企业实名认证'"
    :width="!isIframe ? '800px' : '1200px'"
    :model-value="true"
    custom-class="base-company-dialog"
  >
    <BaseTextContent>
      <BaseForm
        v-if="!isIframe"
        ref="baseFormRef"
        label-position="top"
        :model="formData"
        :column-count="2"
      >
        <div class="base-company-dialog-title" style="margin-top: 0px">
          <span>企业信息（{{ formData.entpStatusName }}）</span>
          <BaseButton
            v-if="formData.isSkip"
            style="margin-left: 6px; height: 30px"
            size="small"
            :loading="loading"
            @click="onResetReal"
          >
            前往实名认证
          </BaseButton>
        </div>

        <div>
          <BaseFormItem label="企业名称" prop="entpName">
            <BaseInput
              class="base-company-dialog-w248"
              type="text"
              placeholder="请输入企业名称"
              disabled
              inputTextReplace
              show-word-limit
              :maxlength="50"
              v-model="formData.entpName"
            ></BaseInput>
          </BaseFormItem>
          <BaseFormItem label="企业证件类型" prop="entpCertNo">
            <BaseSelect
              class="base-company-dialog-w248"
              placeholder="请选择企业证件类型"
              disabled
              :options="Object.values(CERTIFICATE_TYPE)"
              v-model="formData.entpCertType"
            ></BaseSelect>
          </BaseFormItem>
        </div>

        <BaseFormItem label="营业执照" prop="entpCertPic">
          <BaseImage
            style="width: 120px; height: 120px"
            fit="contain"
            :zoom-rate="1.2"
            :max-scale="7"
            :min-scale="0.2"
            :initial-index="4"
            :src="formData.entpCertPic"
            :preview-src-list="[formData.entpCertPic]"
          />
        </BaseFormItem>

        <BaseFormItem label="企业证件编号" prop="entpCertNo">
          <BaseInput
            class="base-company-dialog-w248"
            type="text"
            placeholder="请输入企业证件编号"
            disabled
            show-word-limit
            inputTextReplace
            :inputTexts="['英文字母', '数字']"
            :maxlength="18"
            v-model="formData.entpCertNo"
          />
        </BaseFormItem>
        <BaseFormItem label="法人代表姓名" prop="entpCertNo">
          <BaseInput
            class="base-company-dialog-w248"
            type="text"
            placeholder="请输入法人代表姓名"
            disabled
            show-word-limit
            inputTextReplace
            v-model="formData.legalName"
          />
        </BaseFormItem>

        <div class="base-company-dialog-title">账号登录信息</div>
        <BaseFormItem label="用户名" prop="userName">
          <BaseInput
            class="base-company-dialog-w248"
            placeholder="请输入用户名"
            disabled
            show-word-limit
            :maxlength="11"
            v-model="formData.userName"
          />
        </BaseFormItem>
        <BaseFormItem label="手机号" prop="phone">
          <div
            class="base-company-dialog-w248"
            style="display: flex; align-items: center"
          >
            <BaseInput
              style="flex: 1"
              placeholder="请输入手机号"
              disabled
              show-word-limit
              :maxlength="11"
              v-model="formData.phone"
            />
          </div>
        </BaseFormItem>

        <div class="base-company-dialog-title">
          企业经办人信息（{{ formData.entpStatusName }}）
        </div>
        <BaseFormItem label="姓名" prop="realName">
          <BaseInput
            class="base-company-dialog-w248"
            type="text"
            placeholder="请输入姓名"
            disabled
            show-word-limit
            :maxlength="18"
            v-model="formData.realName"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem label="身份证号" prop="cardId">
          <BaseInput
            class="base-company-dialog-w248"
            placeholder="请输入身份证号"
            disabled
            show-word-limit
            inputTextReplace
            :inputTexts="['英文字母', '数字']"
            :maxlength="18"
            v-model="formData.cardId"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem label="手机号" prop="contactorPhone">
          <div
            class="base-company-dialog-w248"
            style="display: flex; align-items: center"
          >
            <BaseInput
              style="flex: 1"
              placeholder="请输入手机号"
              disabled
              show-word-limit
              inputTextReplace
              :inputTexts="['数字']"
              :maxlength="11"
              v-model="formData.contactorPhone"
            ></BaseInput>
          </div>
        </BaseFormItem>

        <template v-if="isAsp">
          <div class="base-company-dialog-title">开户行信息</div>
          <BaseFormItem
            label="账户名称"
            prop="accountName"
            :rules="[
              {
                required: true,
                message: '请输入账户名称',
                trigger: 'change'
              }
            ]"
          >
            <BaseInput
              class="base-company-dialog-w248"
              type="text"
              placeholder="请输入账户名称"
              v-model="formData.accountName"
            ></BaseInput>
          </BaseFormItem>
          <BaseFormItem
            label="开户行"
            prop="bankName"
            :rules="[
              {
                required: true,
                message: '请输入开户行',
                trigger: 'change'
              }
            ]"
          >
            <BaseInput
              class="base-company-dialog-w248"
              placeholder="请输入开户行"
              v-model="formData.bankName"
            ></BaseInput>
          </BaseFormItem>
          <BaseFormItem
            label="银行账号"
            prop="bankCardNumber"
            :rules="[
              {
                required: true,
                message: '请输入银行账号',
                trigger: 'change'
              }
            ]"
          >
            <div
              class="base-company-dialog-w248"
              style="display: flex; align-items: center"
            >
              <BaseInput
                style="flex: 1"
                placeholder="请输入银行账号"
                v-model="formData.bankCardNumber"
              ></BaseInput>
            </div>
          </BaseFormItem>
        </template>
      </BaseForm>

      <template v-else>
        <iframe
          v-if="redirectUrl"
          ref="iframeRef"
          :src="redirectUrl"
          frameborder="0"
          width="960px"
          height="700px"
          @load="iframeLoad"
        ></iframe>
        <div
          v-else
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            height: 496px;
          "
        >
          加载中 ...
        </div>
      </template>
    </BaseTextContent>

    <template #footer>
      <BaseButton type="default" @click="onCancel">返回</BaseButton>
      <BaseButton v-if="isAsp" :click="onSave">保存</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" setup>
import { withDefaults, defineProps, ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import {
  BaseDialog,
  BaseForm,
  BaseFormRef,
  BaseFormItem,
  BaseInput,
  BaseSelect,
  BaseTextContent,
  BaseImage,
  BaseButton,
  XrkMessage
} from 'xrk-components';
import _ from 'lodash';

import { entpTypeEnum } from '@/common/constants/company/index';
import appStore from '@/store';
import {
  rnvRedirectUrl,
  entpLoginUser,
  entpBankBuild
} from '@/common/data-source/common/apis';
import { formatter } from '@/utils';

const props = withDefaults(
  defineProps<{
    remove?: () => void;
  }>(),
  {}
);

const CERTIFICATE_TYPE = {
  1: { label: '统一社会信用代码', value: 1 },
  2: { label: '工商注册号', value: 2 }
};

const { info, defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
const isAsp = computed(() => defaultUserFnCode.value === entpTypeEnum.FWS);

interface FormData {
  entpName: string;
  userName: string;
  entpCertType: 1 | 2;
  entpCertNo: string;
  entpCertPic: string;
  realName: string;
  cardId: string;
  deptName: string;
  entpStatusName: string;
  entpUserId: number;
  createAt: string;
  authStatus: number;
  contactorPhone: string;
  legalName: string;
  phone: string;
  isSkip: 0 | 1;
  bankCardNumber: string; // 银行账号
  bankName: string; // 开户行
  accountName: string; // 账户名称
  deptId: number;
}

const baseFormRef = ref<BaseFormRef>(null);
const formData = ref<FormData>({
  entpName: '',
  userName: null,
  entpCertType: null,
  entpCertNo: '',
  entpCertPic: '',
  realName: '',
  cardId: null,
  deptName: '',
  entpStatusName: null,
  entpUserId: null,
  createAt: '',
  authStatus: null,
  contactorPhone: null,
  legalName: '',
  phone: '',
  isSkip: null,
  bankCardNumber: null,
  bankName: null,
  accountName: null,
  deptId: null
});

const baseData = ref(null);
const getData = async () => {
  try {
    const res = await entpLoginUser();
    formData.value = {
      ...res.data,
      entpStatusName: !info.value.isSkip ? '已完成实名认证' : '未完成实名认证',
      isSkip: info.value.isSkip,
      createAt: formatter.date(new Date(res.data.createAt))
    };
    baseData.value = _.cloneDeep(formData.value);

    formData.value.entpCertNo = formatter.maskAllMethod({
      type: 'bankCard',
      val: formData.value.entpCertNo
    });
    formData.value.cardId = formatter.maskAllMethod({
      type: 'idCard',
      val: formData.value.cardId
    });
    formData.value.realName = formatter.maskAllMethod({
      type: 'name',
      val: formData.value.realName
    });

    formData.value.phone = formatter.maskAllMethod({
      type: 'phone',
      val: formData.value.phone
    });
    formData.value.contactorPhone = formatter.maskAllMethod({
      type: 'phone',
      val: formData.value.contactorPhone
    });
    formData.value.legalName = formatter.maskAllMethod({
      type: 'name',
      val: formData.value.legalName
    });
  } catch (error) {
    console.log(error);
  }
};
getData();

const onCancel = () => props.remove();

const isIframe = ref(false);
const redirectUrl = ref('');
const iframeLoad = () => {
  window.addEventListener('message', async e => {
    if (!['enterprise-real-dialog'].includes(e.data)) return;

    redirectUrl.value = '';
    await getData();
    isIframe.value = false;
  });
};

const loading = ref(false);
const onResetReal = async () => {
  loading.value = true;
  try {
    const res = await rnvRedirectUrl({
      entpName: baseData.value.entpName, // 企业名称
      entpCertPic: baseData.value.entpCertPic, // 营业执照URL
      entpCertType: baseData.value.entpCertType, // 企业证件编码类型1统一社会信用码2工商注册号
      entpCertNo: baseData.value.entpCertNo, // 企业证件号
      legalName: baseData.value.legalName, // 企业法人姓名
      contactor: baseData.value.realName, // 联系人姓名
      contactorPhone: baseData.value.contactorPhone, // 联系人手机号
      contactId: baseData.value.cardId, // 联系人身份证号
      redirectUrl:
        window.location.origin +
        '/#/main/enterprise-real/enterprise-real-redirect?type=dialog', // E签宝实名完成前端跳转页面
      deptId: info.value.deptId, // 部门id
      isSkip: baseData.value.isSkip,
      entityType: info.value.entpType
    });
    loading.value = false;
    redirectUrl.value = res?.data?.authShortUrl || res?.data?.authUrl;
    if (!redirectUrl.value) {
      XrkMessage.error('地址获取失败');
      return;
    }

    isIframe.value = true;
  } catch (error) {
    loading.value = false;
  }
};

const validate = async () => {
  try {
    await baseFormRef.value.validate();
  } catch (error) {
    const timer = setTimeout(() => {
      clearTimeout(timer);
      const el = document.querySelectorAll('.xrk-form-item__error');
      el?.[0]?.scrollIntoView({
        block: 'center',
        inline: 'center',
        behavior: 'smooth'
      });
    }, 200);
    return Promise.reject();
  }
};
const onSave = async () => {
  try {
    await validate();
    await entpBankBuild({
      bankCardNumber: formData.value.bankCardNumber,
      bankName: formData.value.bankName,
      accountName: formData.value.accountName,
      deptId: formData.value.deptId
    });
    XrkMessage.success('操作成功');
    props.remove();
  } catch (error) {
    console.log(error);
  }
};
</script>

<style lang="scss" scoped>
.base-company-dialog {
  .base-company-dialog-w248 {
    width: 100%;
  }

  .base-company-dialog-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1d2129;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin: 24px 0;

    grid-column-start: 1;
    grid-column-end: 3;
  }
}
</style>
